import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    serverDown: false
  },
  reducers: {
    setServerDown: (state, { payload }) => {
      state.serverDown = payload;
    }
  }
});

export const { setServerDown } = uiSlice.actions;

export default uiSlice.reducer;
